import React from 'react';
import BaseDialogContainer from '../baseContainers/BaseDialogContainer';
import {withTranslation} from 'react-i18next';
import PropTypes from 'prop-types';
import DivContainer from '../components/DivContainer';
import {ActionButton} from '../components/ActionButton';
import CardUserService from '../services/CardUserService';
import CardService from '../services/CardService';
class CardUnauthorizeDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new CardUserService());
        this.cardService = new CardService();
        this.state = {
            viewMode: this.props.viewMode,
        };
        this.renderFooter = this.renderFooter.bind(this);
        this.renderSaveLabel = this.renderSaveLabel.bind(this);
    }
    getContainerListName() {
        return 'user-card-list-container';
    }
    renderSaveLabel() {
        const {t} = this.props;

        return !this.props.fromCardDetailsMode
            ? `${t('cards.cardUnauthorizeConfirmButton1')}${this.props.selectedList ? this.props.selectedList.length : ''}${
                  this.props.selectedList && this.props.selectedList.length > 1
                      ? t('cards.cardUnauthorizeConfirmButton2Plural')
                      : t('cards.cardUnauthorizeConfirmButton2Singular')
              }`
            : t('cards.cardUnauthorizeHeader');
    }
    renderFooter() {
        const {t} = this.props;
        return (
            <div className='footer-dialog-button-container'>
                <ActionButton
                    label={t('details.cancel')}
                    variant={'button cancel-button white'}
                    handleClick={(e) => this.props.onHide(undefined)}
                />
                <ActionButton label={this.renderSaveLabel()} variant='button save-button fullred' handleClick={this.handleFormSubmit} />
            </div>
        );
    }
    translate(key) {
        const {t} = this.props;
        return t(key);
    }

    renderHeader() {
        const {t} = this.props;
        return (
            <React.Fragment>
                <DivContainer colClass='col-12 back-off-auth-dialog-header'>
                    <DivContainer colClass='col-12'>
                        <label id={`back-off-auth-dialog-header-label-id`}>
                            {!this.props.fromCardDetailsMode
                                ? t('cards.cardUnauthorizeHeader')
                                : `${t('cards.cardUnauthorizeDetailsHeader')}: ${this.props.cardNumber}`}
                        </label>
                    </DivContainer>
                </DivContainer>
            </React.Fragment>
        );
    }
    setElement() {
        this.initAfterSetElement();
    }
    createOrUpdate() {
        const {t} = this.props;
        this.scrollToTop();
        if (this.props._isMounted) {
            if (this.props.fromCardDetailsMode) {
                const phoneNumber = this.props.phoneNumber;
                const cardNumber = this.props.cardNumber;
                this.cardService
                    .unauthorizeCard(cardNumber, phoneNumber)
                    .then((response) => {
                        this.blockUi();
                        if (this.props.afterSave) {
                            this.persistMessage('success', '', t('cards.successBackOffAuth'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleSuccess) {
                            this.unblockUi();
                            this.props.handleSuccess(response);
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.persistMessage('error', '', t('error.errorBackOffAuth'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleError) {
                            this.unblockUi();
                            this.props.handleError();
                        }
                    });
            } else {
                const request = {phoneNumbers: this.props?.selectedList?.map((l) => l.phoneNumber)};
                this.service
                    .unauthorizeMobileUser(request)
                    .then((response) => {
                        this.blockUi();
                        if (this.props.afterSave) {
                            this.persistMessage('success', '', t('cards.successBackOffAuth'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleSuccess) {
                            this.unblockUi();
                            this.props.handleSuccess(this.state.element);
                        }
                    })
                    .catch((err) => {
                        if (this.props.afterSave) {
                            this.persistMessage('error', '', t('error.errorBackOffAuth'));
                            this.unblockUi();
                            this.props.afterSave();
                        }
                        if (this.props.handleError) {
                            this.unblockUi();
                            this.props.handleError();
                        }
                    });
            }
        }
    }

    renderDetails() {
        let num = '';
        if (!this.props.fromCardDetailsMode && this.props.selectedList) {
            const numbers = this.props.selectedList.map((l) => l.phoneNumber);
            num = numbers.join(', ');
        } else {
            num = this.props.phoneNumber;
        }
        const {t} = this.props;
        return (
            <div className='back-off-container'>
                <DivContainer colClass=''>
                    <span>{t('cards.cardUnauthorizeNumbers')}</span>
                    <span className='bold'>{num}</span>
                </DivContainer>
                <DivContainer colClass='back-off-row'>
                    <div className='back-off-auth-label'>{t('cards.cardUnauthorizeDesc')}</div>
                </DivContainer>
            </div>
        );
    }
}

CardUnauthorizeDialog.defaultProps = {
    currentUser: undefined,
    viewMode: 'VIEW',
    fromCardDetailsMode: false,
};

CardUnauthorizeDialog.propTypes = {
    currentUser: PropTypes.object,
    viewMode: PropTypes.string,
    visible: PropTypes.bool,
    onHide: PropTypes.func,
    afterSave: PropTypes.func,
    selectedList: PropTypes.array,
    fromCardDetailsMode: PropTypes.bool,
    phoneNumber: PropTypes.string,
    cardNumber: PropTypes.string,
};

export default withTranslation()(CardUnauthorizeDialog);
